import { render, staticRenderFns } from "./ElementTypesDropdown.vue?vue&type=template&id=5b8bd4f7&"
import script from "./ElementTypesDropdown.vue?vue&type=script&lang=ts&"
export * from "./ElementTypesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports